import { render, staticRenderFns } from "./PointsLog.vue?vue&type=template&id=3094bf39&scoped=true&"
import script from "@/scripts/Points/components/PointsLog.js?vue&type=script&lang=js&"
export * from "@/scripts/Points/components/PointsLog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3094bf39",
  null
  
)

export default component.exports